import { render, staticRenderFns } from "./MypageAboutUsingPage.vue?vue&type=template&id=4cb9ab47"
import script from "./MypageAboutUsingPage.vue?vue&type=script&lang=ts"
export * from "./MypageAboutUsingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports